import { render, staticRenderFns } from "./unitDatabase.vue?vue&type=template&id=660a930a&scoped=true"
import script from "./unitDatabase.vue?vue&type=script&lang=js"
export * from "./unitDatabase.vue?vue&type=script&lang=js"
import style0 from "./unitDatabase.vue?vue&type=style&index=0&id=660a930a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a930a",
  null
  
)

export default component.exports